import { render } from "./ReferralComments.vue?vue&type=template&id=11292f68&ts=true"
import script from "./ReferralComments.vue?vue&type=script&lang=ts"
export * from "./ReferralComments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__